import _uniq from 'lodash/uniq';

import { FLOW_STEP_PATHS } from '@/constants';
import { not } from '@/flow/common';
import { isMerchantRegistered, isSoleTraderOrSoleProprietorship } from '@/flow/configs/selectors';
import SoleTrader from '@/containers/SoleTrader';

export class SoleTraderBlock {
  constructor({ isManagedFlow, back, next, prerequisite = [] }) {
    this.isManagedFlow = isManagedFlow;
    this.back = back;
    this.next = next;
    this.prerequisite = _uniq([
      'isSoleTraderOrSoleProprietorship',
      not('isMerchantRegistered'),
      ...prerequisite,
    ]);
  }

  static selectors = {
    isMerchantRegistered,
    isSoleTraderOrSoleProprietorship,
  };

  getSelectors() {
    return SoleTraderBlock.selectors;
  }

  withGlobalPrerequisites(prerequisite = []) {
    return _uniq([...prerequisite, ...(this.prerequisite || [])]);
  }

  generateFlowConfig() {
    return [
      {
        id: 'sole-trader',
        path: FLOW_STEP_PATHS.SOLE_TRADER_PATH,
        prerequisite: this.withGlobalPrerequisites(['isSoleTraderOrSoleProprietorship']),
        Container: SoleTrader,
        back: this.back,
        next: this.next,
      },
    ];
  }
}
